module.exports = __webpack_public_path__ + "static/media/0030_LES_STRUCTURES_ILV.b5c49868.png";